import { combineReducers } from 'redux';
import modalReducer from '../containers/Modal/reducer';
import { ReduxState } from './types';

export default function createReducers() {
  return combineReducers<ReduxState>({
    modal: modalReducer,
  });
}
